  <!-- 资金调拨 -->
  <template>
  <div>
    <!-- 按钮列表 -->
    <butotn-plug
      :btndata="BTN_CONFIG"
      @btnEvent="callBack"
      @clearBtns="clearBtns"
      @moreParam="moreParam"
      @queryBtn_ok="queryBtn_ok"
      @moreHandle="topCommandBtns"
      ref="btnList"
    />
    <!-- 查询列表 -->
    <input-plug
      ref="queryForm"
      :form-config="baseConfig"
      :form-data="queryData"
      :More="isHaseMore"
    />

    <!-- 表格 -->
    <table-plug
      :tableConfig="tableConfig"
      :defaulthead="myTableHeard"
      :totals="totalArr"
      ref="mytable"
      @rowCallback="rowCallback"
      @selectChange="handleSelectionChange"
      @jumpPage="goYdDetails"
    />
    <!-- 分页 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    />

    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    />

    <!-- 整单核销 -->
    <my-dialog
      :diaWidth="diaWidth"
      :dialogTitle="dialogTitle"
      :dialogFooter="false"
      :isShowDialog="isShowDialog"
      @handleCloseDia="handleCloseDia"
    >
      <div>
        <div>
          <el-button v-if="ComfirmDatashow" class="diaBtns" @click="ComfirmData"
            >保存</el-button
          >
          <el-button v-if="!ComfirmDatashow" class="diaBtns" @click="outConfirm"
            >转出确认</el-button
          >
          <el-button v-if="!ComfirmDatashow" class="diaBtns" @click="cancelOut"
            >转出取消</el-button
          >
          <el-button
            v-if="!ComfirmDatashow"
            class="diaBtns"
            @click="comeinConfirm"
            >转入确认</el-button
          >
        </div>
        <dia-form
          :diaFormConfig="diaFormConfig"
          :baseModel="baseModel"
          ref="diaform"
          :rules="formRules"
          :Reset="isShowDialog"
        />
      </div>
    </my-dialog>
    <my-dialog
      diaWidth="1200px"
      dialogTitle="交账调拨"
      :isShowDialog="showPayRecordDialog"
      @handleCloseDia="handleClosePayRecord"
      @diaCancelBtn="handleClosePayRecord"
      @diaConfirmBtn="handleConfirmPayRecord"
    >
      <payment-allocation-record
        ref="record"
        :allocationId="baseModel.allocationId"
        v-if="showPayRecordDialog"
        :readonly="allocationReadonly"
        :comment-write-only="allocationCommentWriteOnly"
      ></payment-allocation-record>
    </my-dialog>
    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
      <input-plug
        ref="queryForm"
        :form-config="baseConfig"
        :form-data="queryData"
        :More="true"
      />
      <!-- 查询列表 -->
    </exportCompoent>
    <my-print
      :classNameArr="classNameArr"
      :modelClassName.sync="modelClassName"
      :getApiType.sync="getApiType"
      modelTypeVal="资金账户模块"
      ref="myPrint"
      :dataSource="printDataSource"
      :add-permission="printPermission"
      :edit-permission="printPermission"
      :del-permission="printPermission"
    ></my-print>
  </div>
</template>
  <script >
import { mixin_1 } from "@/assets/js/Mixins/mixin";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import ButotnPlug from "@/components/Modules/ButtonPlug.vue";
import InputPlug from "@/components/Modules/InputPlug.vue";
import multitime from "@/components/multiTime.vue";
import paging from "@/components/pagings.vue"; //分页组件
import TablePlug from "@/components/Modules/TablePlug.vue";
import MyDialog from "@/components/Dialog.vue";
import DiaForm from "@/pages/VMS/VMSConpon/DiaForm.vue";
import ImgUpload from "@/components/Modules/ImgUpload.vue";
import RecordTable from "@/pages/FinancialManagement/FinancialWriteOff/FMMOD/RecordTable.vue";
import exportjs from "@/assets/js/Mixins/export.js"; //导出的公共js
import PaymentAllocationRecord from "./PaymentAllocationRecord.vue";
import MyPrint from "@/components/print/MyPrint.vue";
export default {
  mixins: [mixin_1, exportjs],
  components: {
    ButotnPlug,
    InputPlug,
    multitime,
    TablePlug,
    paging,
    sorttable,
    MyDialog,
    DiaForm,
    ImgUpload,
    RecordTable,
    PaymentAllocationRecord,
    MyPrint,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: "",
        fileName: "资金调拨列表", //导出时默认文件名
        apiName:
          "/admin/v3/finance/allocation/record/getAllocationRecordListV2", //导出的数据列表接口名(动态列表都是这个)
        EpType: "bdd", //dd==等待下载完成,bdd==不等待完成
        apiType: "GET", //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      // 按钮配置
      BTN_CONFIG: [
        {
          name: "新建调拨",
          method: "addClick",
          permissVal: "admin:finance_allocation:addAllocationRecordV2",
        },
        {
          name: "交账调拨",
          method: "addPaymentAllocationRecord",
          permissVal: "aaaaa",
        },
        {
          name: "详情",
          method: "detailClick",
          permissVal: "aaaaa",
        },
        {
          name: "修改",
          method: "updateClick",
          permissVal: "aaaaa",
        },
        {
          name: "删除",
          method: "delete",
          permissVal: "admin:finance_allocation:deleteRecordV2",
        },
        {
          name: "转出确认",
          method: "outConfirm",
          permissVal: "admin:finance_allocation:outSureV2",
        },
        {
          name: "取消转出",
          method: "cancelOut",
          permissVal: "admin:finance_allocation:cancelOutV2",
        },
        {
          name: "转入确认",
          method: "comeinConfirm",
          permissVal: "admin:finance_allocation:inSureV2",
        },
        {
          name: "取消转入",
          method: "comeinConfirmCancel",
          permissVal: "admin:finance_allocation:inSureV2",
        },
        {
          name: "打印",
          method: "printFn",
          permissVal: "",
        },
        {
          type: true,
          name: "更多操作",
          options: [
            {
              handleName: "dc",
              label: "导出",
            },
            {
              handleName: "bgsz",
              label: "表格设置",
            },
            // {
            //   handleName: "dy",
            //   label: "打印",
            // },
          ],
        },
      ],
      // 更多搜索
      isHaseMore: false,
      dialogTitle: "资金调拨",
      //  查询框
      baseConfig: [
        {
          type: "input",
          label: "调拨单号",
          field: "number",
          placeholder: "请输入",
        },
        {
          type: "select",
          label: "调拨状态",
          field: "allocationStatus",
          placeholder: "请输入",
          selectOptions: [
            { label: "未转出", val: "wei_zhuan_chu:allocation_status" },
            { label: "已转出", val: "yi_zhuan_chu:allocation_status" },
            { label: "已转进", val: "yi_zhuan_jin:allocation_status" },
          ],
        },
        {
          type: "input",
          label: "转出账号",
          field: "outFinanceAssetaccountNumber",
          placeholder: "请输入",
        },
        {
          type: "input",
          label: "转进账号",
          field: "inFinanceAssetaccountNumber",
          placeholder: "请输入",
        },
        {
          type: "select",
          label: "转出网点",
          field: "outFinanceAssetaccountDeptId",
          placeholder: "请输入",
          selectOptions: this.businessDepts,
        },
        {
          type: "select",
          label: "转入网点",
          field: "inFinanceAssetaccountDeptId",
          placeholder: "请输入",
          selectOptions: this.businessDepts,
        },
      ],

      queryData: {
        allocationStatus: null,
        inFinanceAssetaccountNumber: null,
        number: null,
        outFinanceAssetaccountNumber: null,
        outFinanceAssetaccountDeptId:
          this.$TOOLS.getUserInfo().departmentId || null,
        inFinanceAssetaccountDeptId:
          this.$TOOLS.getUserInfo().departmentId || null,
      },

      // 表格配置
      tableConfig: {
        tableHeigth: "75vh",
        tableData: [],
      },
      myTableHeard: [],
      tabelHeadeTitle: [
        {
          name: "操作",
          field: "edit",
          width: 140,
          Buttons: [
            {
              method: "detailClick",
              methodName: "详情",
              permissVal: "admin:finance_allocation:getAllocationRecordListV2",
            },
            {
              method: "delete",
              methodName: "删除",
              permissVal: "admin:finance_allocation:deleteRecordV2",
            },
          ],
        },
        {
          name: "调拨单号",
          field: "number",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "调拨分类",
          field: "documentStatusShow",
          width: "120",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "调拨金额",
          field: "amount",
          sort: 4,
          isShow: true,
          isTotal: true,
          isSort: true,
        },
        {
          name: "转出账号",
          field: "outFinanceAssetaccountNumber",
          sort: 5,
          isShow: true,
        },
        {
          name: "转进账号",
          field: "inFinanceAssetaccountNumber",
          sort: 5,
          isShow: true,
        },
        {
          name: "调拨状态",
          field: "allocationStatusShow",
          sort: 6,
          isShow: true,
        },
        {
          name: "转出网点",
          field: "outFinanceAssetaccountDeptName",
          sort: 5,
          isShow: true,
        },
        {
          name: "转入网点",
          field: "inFinanceAssetaccountDeptName",
          sort: 5,
          isShow: true,
        },
        {
          name: "转出人",
          field: "outUserName",
          sort: 1,
          isShow: true,
        },
        {
          name: "转出时间",
          field: "outTime",
          sort: 1,
          isShow: true,
        },
        {
          name: "转进人",
          field: "inUserName",
          sort: 18,
          isShow: true,
        },
        {
          name: "转进时间",
          field: "inTime",
          sort: 19,
          isShow: true,
        },
        {
          name: "创建人",
          field: "createUserName",
          sort: 1,
          isShow: true,
        },
        {
          name: "备注",
          field: "comment",
          sort: 1,
          isShow: true,
        },
      ],
      sortName: "资金调拨", //  排序名
      pageGroupName: "FundAllocation",
      // 新建
      diaWidth: "60%",

      isShowDialog: false,
      diaFormConfig: [
        {
          gutter: 60,
          formItem: [
            {
              span: 12,
              title: "调拨单号",
              itemType: "input",
              field: "number",
              disabled: true,
              placeholder: "自动生成",
            },
            {
              span: 12,
              title: "调拨金额",
              itemType: "input",
              field: "amount",
              placeholder: "请输入",
            },
          ],
        },
        {
          gutter: 60,
          formItem: [
            {
              span: 12,
              title: "转出账号",
              itemType: "select",
              field: "outFinanceAssetaccountId",
              placeholder: "请选择",
              setLabel: "account",
              setValue: "assetaccountId",
              options: [],
            },
            {
              span: 12,
              title: "转入账号",
              itemType: "select",
              field: "inFinanceAssetaccountId",
              placeholder: "请选择",
              setLabel: "account",
              setValue: "assetaccountId",
              options: [],
            },
          ],
        },
        {
          gutter: 0,
          formItem: [
            {
              span: 24,
              title: "调拨备注",
              itemType: "textarea",
              field: "comment",
              placeholder: "请输入",
            },
          ],
        },
        {
          gutter: 60,
          formItem: [
            {
              span: 12,
              title: "调拨状态",
              itemType: "input",
              field: "allocationStatusShow",
              disabled: true,
              placeholder: "自动切换",
            },
            {
              span: 12,
              title: "创建时间",
              itemType: "input",
              field: "createTime",
              disabled: true,
              placeholder: "自动生成",
            },
          ],
        },
        {
          gutter: 60,
          formItem: [
            {
              span: 12,
              title: "转出人",
              itemType: "input",
              field: "outUserName",
              disabled: true,
              placeholder: "自动生成",
            },
            {
              span: 12,
              title: "转出时间",
              itemType: "input",
              field: "outTime",
              disabled: true,
              placeholder: "自动生成",
            },
          ],
        },
        {
          gutter: 60,
          formItem: [
            {
              span: 12,
              title: "转入人",
              itemType: "input",
              field: "inUserName",
              disabled: true,
              placeholder: "自动生成",
            },
            {
              span: 12,
              title: "转入时间",
              itemType: "input",
              field: "inTime",
              disabled: true,
              placeholder: "自动生成",
            },
          ],
        },
      ],
      baseModel: {
        allocationId: "",
        amount: null,
        comment: null,
        inFinanceAssetaccountId: 0,
        outFinanceAssetaccountId: 0,
      },
      defaultBaseModel: {
        amount: null,
        comment: null,
        inFinanceAssetaccountId: 0,
        outFinanceAssetaccountId: 0,
      },
      ComfirmDatashow: true,
      formRules: {},
      showPayRecordDialog: false,
      businessDepts: [],
      allocationReadonly: false,
      allocationCommentWriteOnly: false,
      classNameArr: [
        {
          name: "资金调拨",
          val: "print_allocation_record_data",
        },
        // {
        //   name: "资金调拨",
        //   val: "com.bami.service.tms.v5.admin.finance.vo.AdminFinanceAllocationRecordPrintDataVO",
        // },
      ], // 默认的模板类型
      modelClassName: "print_allocation_record_data",
      getApiType: false,
    };
  },
  updated() {
    if (this.show_sortTableHeard) {
      // 排序表头
      let arr = this.tabelHeadeTitle;
      for (var i = 0; i < arr.length; i++) {
        arr[i].sort = i + 1;
      }
      this.tabelHeadeTitle = arr;
    }
  },
  created() {
    this.GetData();
    this.GetAssetaccountList();
    this.getBusinessDepts();
  },
  methods: {
    // 获取营业网点
    async getBusinessDepts() {
      const data = await this.$API.runListReport({
        number: "business_dept_down_list",
      });
      this.businessDepts = data;
      this.baseConfig[4].selectOptions = data.map((item) => {
        return {
          label: item.deptName,
          val: item.deptId,
        };
      });
      this.baseConfig[5].selectOptions = data.map((item) => {
        return {
          label: item.deptName,
          val: item.deptId,
        };
      });
    },
    addPaymentAllocationRecord() {
      this.allocationReadonly = false;
      this.allocationCommentWriteOnly = false;
      this.showPayRecordDialog = true;
    },
    handleClosePayRecord() {
      this.showPayRecordDialog = false;
    },
    async handleConfirmPayRecord() {
      // 修改备注
      if (this.allocationCommentWriteOnly) {
        const record = this.$refs.record.getForm();
        const { allocationId, comment } = record;
        await this.$API.updateAllocationRecord({
          allocationId,
          comment,
        });
        this.$message.success("保存成功");
        this.showPayRecordDialog = false;
        this.GetData();
        return;
      }
      if (this.allocationReadonly) {
        this.showPayRecordDialog = false;
        return;
      }
      const record = this.$refs.record.getForm();
      await this.$API.addPaymentAllocationRecord({
        ...record,
      });
      this.$message.success("保存成功");
      this.showPayRecordDialog = false;
      this.GetData();
    },

    updateClick() {
      if (this.selectTableData.length !== 1) {
        this.$message.warning("请选择一条记录进行修改");
        return;
      }
      const row = this.selectTableData[0];
      if (row.documentStatus !== "jiao_zhang:document_status") {
        this.baseModel = row;
        this.ComfirmDatashow = true;
        this.isShowDialog = true;
      } else {
        this.baseModel = row;
        this.ComfirmDatashow = false;
        this.showPayRecordDialog = true;
        this.allocationCommentWriteOnly = true;
        this.allocationReadonly = true;
      }
    },
    // 获取资金调拨列表
    GetData() {
      this.queryData.pageStart = this.pageStart;
      this.queryData.pageTotal = this.pageTotal;
      this.$API.AllocationRecordListV2(this.queryData).then((res) => {
        if (res.data.status === "success") {
          this.className = res.data.result.className || "";
          this.tableConfig.tableData = res.data.result.data || [];
          this.pageCount = res.data.result.pageCount || 0;
          this.$nextTick(() => {
            this.fetTableHeight();
          });
        } else {
          this.$message.error(`${res.data.message}---资金调拨列表`);
        }
      });
    },

    // 获取资金账号列表
    GetAssetaccountList() {
      this.$API
        .assetaccountList({
          isSelectByLoginUser: 1,
        })
        .then((res) => {
          if (res.data.status === "success") {
            let result = res.data.result?.data || [];
            this.diaFormConfig[1].formItem[0].options = result;
          } else {
            this.$message.error(`${res.data.message}`);
          }
        });
      this.$API.assetaccountList().then((res) => {
        if (res.data.status === "success") {
          let result = res.data.result?.data || [];
          this.diaFormConfig[1].formItem[1].options = result;
        } else {
          this.$message.error(`${res.data.message}`);
        }
      });
    },

    // 表格内按钮的回调事件
    rowCallback(data, name) {
      this[name](data);
    },

    // 新建
    addClick() {
      this.ComfirmDatashow = true;
      this.baseModel = {};
      this.isShowDialog = true;
    },
    // 详情
    detailClick(data) {
      if (data) this.selectTableData = [data];
      if (!data) data = this.selectTableData[0];
      if (this.selectTableData.length < 1) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      } else {
        if (data.documentStatus !== "jiao_zhang:document_status") {
          this.baseModel = data;
          this.ComfirmDatashow = false;
          this.isShowDialog = true;
        } else {
          this.baseModel = data;
          this.ComfirmDatashow = false;
          this.showPayRecordDialog = true;
          this.allocationReadonly = true;
        }
      }
    },
    // 删除
    delete(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length < 1) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      } else {
        this.$confirm("确定要删除所选数据吗?", "提示:")
          .then((res) => {
            let delReq = {
              allocationIds: new Array(),
            };
            this.selectTableData.map(function (val, i) {
              delReq.allocationIds.push(val.allocationId);
            });
            this.$API.deleteRecordV2_V2(delReq).then((res) => {
              if (res.data.status === "success") {
                try {
                  let num = 0;
                  let arr = this.tableConfig.tableData;
                  if (delReq.allocationIds.length > 2) {
                    delReq.allocationIds.map(function (v, i) {
                      num = arr.findIndex(
                        (element) => element.allocationId == v
                      );
                      arr.splice(num, 1);
                    });
                  } else {
                    num = arr.findIndex(
                      (element) =>
                        element.allocationId == delReq.allocationIds[0]
                    );
                    arr.splice(num, 1);
                  }
                } catch {
                  this.GetData();
                }
                this.$message.success("已删除");
              }
            });
          })
          .catch((err) => {
            if (data) this.selectTableData.length = 0;
            console.log(err);
          });
      }
    },
    // 转出确认
    outConfirm(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length < 1) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      } else {
        this.$confirm("确定要把所选数据做转出确认?", "提示:")
          .then((res) => {
            let delReq = {
              allocationIds: new Array(),
            };
            this.selectTableData.map(function (val, i) {
              delReq.allocationIds.push(val.allocationId);
            });
            this.$API.outSureV2(delReq).then((res) => {
              if (res.data.status === "success") {
                this.$message.success(res.data.message);
                if (this.isShowDialog) {
                  this.handleCloseDia();
                }
                this.GetData();
              }
            });
          })
          .catch((err) => {
            if (data) this.selectTableData.length = 0;
          });
      }
    },
    // 取消转出
    cancelOut(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length < 1) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      } else {
        this.$confirm("确定要把所选数据取消转出?", "提示:")
          .then((res) => {
            let delReq = {
              allocationIds: new Array(),
            };
            this.selectTableData.map(function (val, i) {
              delReq.allocationIds.push(val.allocationId);
            });
            this.$API.cancelOutV2(delReq).then((res) => {
              if (res.data.status === "success") {
                this.$message.success(res.data.message);
                if (this.isShowDialog) {
                  this.handleCloseDia();
                }
                this.GetData();
              }
            });
          })
          .catch((err) => {
            if (data) this.selectTableData.length = 0;
          });
      }
    },
    // 转入确认
    comeinConfirm(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length < 1) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      } else {
        this.$confirm("确定要把所选数据确认转入?", "提示:")
          .then((res) => {
            let delReq = {
              allocationIds: new Array(),
            };
            this.selectTableData.map(function (val, i) {
              delReq.allocationIds.push(val.allocationId);
            });
            this.$API.inSureV2(delReq).then((res) => {
              if (res.data.status === "success") {
                this.$message.success(res.data.message);
                if (this.isShowDialog) {
                  this.handleCloseDia();
                }
                this.GetData();
              }
            });
          })
          .catch((err) => {
            if (data) this.selectTableData.length = 0;
          });
      }
    },
    comeinConfirmCancel(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length < 1) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      } else {
        this.$confirm("确定要把所选数据取消转入?", "提示:")
          .then((res) => {
            let delReq = {
              allocationIds: new Array(),
            };
            this.selectTableData.map(function (val, i) {
              delReq.allocationIds.push(val.allocationId);
            });
            const allocationIds = delReq.allocationIds;
            // const allocationIds = this.selectTableData.map(item.allocationId);
            this.$API
              .cancelInSureV5({
                allocationIds,
              })
              .then((res) => {
                if (res.data.status === "success") {
                  this.$message.success(res.data.message);
                  if (this.isShowDialog) {
                    this.handleCloseDia();
                  }
                  this.GetData();
                }
              });
          })
          .catch((err) => {
            console.log(err);
            if (data) this.selectTableData.length = 0;
          });
      }
    },
    // 弹窗保存
    ComfirmData() {
      // 编辑修改
      if (this.baseModel.allocationId) {
        const { allocationId, comment } = this.baseModel;
        this.$API
          .updateAllocationRecord({
            allocationId,
            comment,
          })
          .then((res) => {
            if (res.data.status === "success") {
              this.$message.success(res.data.message);
              this.handleCloseDia();
              this.GetData();
            }
          });
        return;
      }
      // 正常提交
      let param = {};
      for (let key in this.defaultBaseModel) {
        if (this.baseModel[key] || this.baseModel[key] == 0) {
          eval("param." + key + "='" + this.baseModel[key] + "'");
        } else {
          eval("param." + key + "=''");
        }
      }
      param.fileIds = [];
      this.$API.addAllocationRecordV2(param).then((res) => {
        if (res.data.status === "success") {
          this.$message.success(res.data.message);
          this.handleCloseDia();
          this.GetData();
        }
      });
    },
    // 更多搜索
    moreParam(e) {
      this.isHaseMore = e;
      this.$nextTick(() => {
        this.fetTableHeight();
      });
    },

    printFn() {
      // 打印
      this.getApiType = true;
      this.printEvent();
    },
    //顶部跟多按钮的操作
    topCommandBtns(a) {
      if (a === "bgsz") {
        // 设置模板按钮
        // this.myModel();
        this.$TOOLS.myModel(this);
      }
      if (a === "dy") {
        // 打印运单
        this.printEvent();
      }
      if (a === "dybq") {
        // 打印标签
      }
      if (a === "dr") {
        // 导入
      }
      if (a === "dc") {
        // // 导出
        // this.$COMAPI.exportBtn({
        //   pageGroupName: this.pageGroupName, //页面标识
        //   myTableHeard: this.myTableHeard, //表头数组
        //   className: this.className, //列表标识
        //   tableData: this.tableConfig.tableData, //数据源
        //   sheetName: "表名(暂无效)", //表名
        // });
        this.isShowDialog_dc = true;
      }
    },

    printEvent(row) {
      if (!row && this.selectTableData.length === 0) {
        this.$message.warning("请选择一条记录打印");
        return;
      }
      this.$refs.myPrint.printEvent(row ? [row] : this.selectTableData);
    },
    // 清空查询
    clearBtns() {
      this.$refs["queryForm"].$refs.forms.resetFields();
      this.GetData();
    },
    // 查询事件
    queryBtn_ok() {
      this.GetData();
    },
    // // 表格选择事件
    handleSelectionChange(e) {
      this.selectTableData = e;
    },
    // 跳转运单详情
    goYdDetails(a) {
      this.$message.success("你点我干嘛");
    },

    // 整单核销
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia(e) {
      this.baseModel = {};
      this.selectTableData.length = 0;
      this.$refs.mytable.$refs.tables.clearSelection();
      this.isShowDialog = false;
    },
    printDataSource(rows, modelClassName) {
      return new Promise((resolve, reject) => {
        this.$API
          .runList({
            number: this.modelClassName,
            allocationIds: rows.map((d) => d.allocationId),
          })
          .then((res) => {
            const result = res;
            resolve(result);
          })
          .catch((err) => {});
      });
      // return new Promise((resolve, reject) => {
      //   this.$API
      //     .getFinanceAllocationRecordPrintData({
      //       allocationId: rows[0].allocationId,
      //     })
      //     .then((res) => {
      //       const result = res.data.result;
      //       resolve(result);
      //     })
      //     .catch((err) => {});
      // });
    },

    printPermission(action) {
      return "aaaaa";
    },
  },
};
</script>
  <style scoped lang="less">
.diaBtns {
  width: 80px;
  padding: 10px;
  line-height: 10px;
  background: rgb(10, 146, 209);
  color: #fff;
}
</style>
  